import { render, staticRenderFns } from "./JsonPretty.vue?vue&type=template&id=4f4b8574&"
import script from "./JsonPretty.vue?vue&type=script&lang=js&"
export * from "./JsonPretty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports